import React from "react";
import Cover from "../../components/cover/cover";
import Schedule from "../../components/myschedule/schedule";
import { useLocation } from "react-router-dom";
import Navigation, { getContainerClass } from "../../components/navigation/navigation";
// import Header from "../../components/header/header";
const SchedulePage = () => {
  const breadcrumb = ["Home", "Schedule"];
  const location = useLocation();

  return (
    <>
      <div className={getContainerClass(location.pathname)}>
        {/* <Header /> */}
        <Cover breadcrumb={breadcrumb} page="schedule" />
        <div>
          <Schedule />
        </div>
      </div>
    </>
  );
};

export default SchedulePage;
